import { CSSProperties } from 'react';

import ChevronDown from '@spotnana/pixel-react/dist/Icons/ChevronDown';
import spotnanaTheme from '@spotnana/pixel-react/dist/utils/themes/theme';
import { ExpandButtonVariant } from './types';
import { Button } from './styles';

interface IExpandButtonProps {
  dataTestId?: string;
  ariaLabel?: string;
  variant?: ExpandButtonVariant;
  expanded: boolean;
  onClick: VoidFunction;
  chevronWidth?: number;
  chevronHeight?: number;
  buttonStyles?: CSSProperties;
  disabled?: boolean;
}

export default function ExpandButton({
  dataTestId,
  ariaLabel,
  variant = 'default',
  expanded = false,
  onClick,
  chevronHeight = 8,
  chevronWidth = 8,
  buttonStyles,
  disabled,
}: IExpandButtonProps): JSX.Element {
  return (
    <Button
      type="button"
      data-testid={dataTestId}
      aria-label={ariaLabel}
      expanded={expanded}
      variant={variant}
      disabled={disabled}
      onClick={onClick}
      style={buttonStyles}
    >
      <ChevronDown
        width={chevronWidth}
        height={chevronHeight}
        primaryColor={buttonStyles?.textDecorationColor || spotnanaTheme.colors.text.blackcurrant}
      />
    </Button>
  );
}
